import API from "../api";

export const enrollByStaff = (role, payload) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "ADMIN"
      ? "/admin/enrollments"
      : normalizedRole === "MANAGER"
        ? "/manager/enrollments"
        : "/coach/enrollments";
  return API.post(base, payload);
};

export const enrollSelf = (payload) =>
  API.post("/student/enrollments", payload);
export const myEnrollments = () => API.get("/student/enrollments");

// NEW: listings + archive
export const listEnrollments = (role, params = {}) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "ADMIN"
      ? "/admin/enrollments/search"
      : normalizedRole === "MANAGER"
        ? "/manager/enrollments/search"
        : "/coach/enrollments/search";
  return API.get(base, { params });
};

export const archiveEnrollment = (role, id, endEnrollmentDate) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "ADMIN"
      ? "/admin/enrollments"
      : normalizedRole === "MANAGER"
        ? "/manager/enrollments"
        : "/coach/enrollments";
  return API.put(`${base}/${id}/archive`, { endEnrollmentDate });
};

export const activateEnrollment = (role, id) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "ADMIN"
      ? "/admin/enrollments"
      : normalizedRole === "MANAGER"
        ? "/manager/enrollments"
        : "/coach/enrollments";
  return API.put(`${base}/${id}/activate`);
};

// Admin / manager: update enrollment
export const updateEnrollment = (role, id, payload) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "MANAGER" ? "/manager/enrollments" : "/admin/enrollments";
  return API.put(`${base}/${id}`, payload);
};

export const getEnrollment = (role, id) => {
  const normalizedRole = role.toUpperCase();
  const base =
    normalizedRole === "MANAGER" ? "/manager/enrollments" : "/admin/enrollments";
  return API.get(`${base}/${id}`);
};

// Manager: Pre-archive check — returns scope validation + cross-branch warning info
export const checkArchiveEnrollment = (id) =>
  API.get(`/manager/enrollments/${id}/archive-check`);
